import {Component, OnInit} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DataService} from '../../../../Services/data.service';
import {WoUserBillingRate, WO_WORK_TYPES} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-wo-user-billing-rate-list',
  templateUrl: './wo-user-billing-rate-list.component.html',
  standalone: false,
})
export class WoUserBillingRateListComponent implements OnInit {

  rows: WoUserBillingRate[] = [];
  users: any[] = [];
  workTypes = WO_WORK_TYPES;
  isLoaded = false;
  editingRow: Partial<WoUserBillingRate> | null = null;
  isNew = false;

  constructor(
    private woService: WorkOrderService,
    private dataService: DataService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.dataService.getDataWithParams('sys_user', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => {
        this.users = r?.Data ?? r?.data ?? r ?? [];
      }, error: () => {
      }
    });
    this.load();
  }

  load(): void {
    this.woService.getUserBillingRates().subscribe({
      next: (r: any) => {
        this.rows = r?.Data ?? r?.data ?? r ?? [];
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  startNew(): void {
    this.editingRow = {user_id: '', work_type: 'regular', base_rate: 0, rate_modifier: 1, effective_rate: 0, active: true};
    this.isNew = true;
  }

  startEdit(row: WoUserBillingRate): void {
    this.editingRow = {...row};
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editingRow = null;
  }

  onRateChange(): void {
    if (this.editingRow) {
      this.editingRow.effective_rate = Math.round((this.editingRow.base_rate || 0) * (this.editingRow.rate_modifier || 1) * 100) / 100;
    }
  }

  save(): void {
    if (!this.editingRow?.user_id || !this.editingRow?.work_type) {
      return;
    }
    const obs = this.isNew
      ? this.woService.createUserBillingRate(this.editingRow)
      : this.woService.updateUserBillingRate((this.editingRow as WoUserBillingRate).id, this.editingRow);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Saved.');
        this.editingRow = null;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving.');
      }
    });
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(['Delete this billing rate?'],
      () => {
        this.woService.deleteUserBillingRate(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }

  userName(userId: string): string {
    const u = this.users.find(x => x.id === userId);
    return u ? u.name : userId;
  }
}
